import { Directive, ElementRef, HostListener, Input, OnInit, Renderer2, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { SsrService } from '@services/ssr.service';

@Directive({
  selector: '[app-ripple]',
})
export class RippleDirective implements OnInit {
  private el = inject(ElementRef);
  private renderer = inject(Renderer2);
  private document = inject<Document>(DOCUMENT);
  private ssrService = inject(SsrService);
  @Input('ripple-color') rippleColor?: string;
  @Input('ripple-dynamic-duration') rippleDynamicDuration?: boolean;
  @Input('ripple-disabled') rippleDisabled?: boolean;
  private rippleEl?: HTMLElement;
  private setTimeout: any;
  private setTimeoutRemove: any;

  @HostListener('mouseenter', ['$event']) onMouseEnter(e: MouseEvent): void {
    if (this.ssrService.isServer()) return;
    if (this.rippleDisabled) return;
    const effect = this.el.nativeElement.querySelector('.ripple__effect');
    if (effect) {
      effect.remove();
      clearTimeout(this.setTimeoutRemove);
    }
    const rippleMain: HTMLElement | null = this.el.nativeElement.querySelector('.ripple__main');
    const el: HTMLElement = rippleMain ? rippleMain : this.el.nativeElement;
    const size: number = el.clientWidth > el.clientHeight ? 2.75 * el.clientWidth : 2.75 * el.clientHeight;
    this.rippleEl = this.document.createElement('div');
    this.rippleEl.classList.add('ripple__effect');
    this.rippleEl.style.width = this.rippleEl.style.height = size + 'px';
    const offsetY: number = e.offsetY > el.clientHeight ? el.clientHeight : e.offsetY < 0 ? 0 : e.offsetY;
    this.rippleEl.style.top = offsetY - size / 2 + 'px';
    const offsetX: number = e.offsetX > el.clientWidth ? el.clientWidth : e.offsetX < 0 ? 0 : e.offsetX;
    this.rippleEl.style.left = offsetX - size / 2 + 'px';
    if (this.rippleDynamicDuration) this.rippleEl.style.transitionDuration = size / 1.2 + 'ms';
    if (this.rippleColor) this.rippleEl.style.backgroundColor = this.rippleColor;
    this.renderer.appendChild(el, this.rippleEl);
    this.setTimeout = setTimeout(() => {
      if (this.rippleEl) {
        this.rippleEl.style.opacity = '1';
        this.rippleEl.style.transform = 'scale3d(1, 1, 1)';
      }
    }, 10);
  }

  @HostListener('mouseleave') onMouseLeave(): void {
    if (this.rippleDisabled) return;
    if (this.rippleEl) {
      if (this.setTimeout) clearTimeout(this.setTimeout);
      this.el.nativeElement.querySelector('.ripple__effect').style.opacity = '0';
      this.setTimeoutRemove = setTimeout(() => {
        if (this.rippleEl) {
          this.rippleEl.remove();
          this.rippleEl = undefined;
        }
      }, 1500);
    }
  }

  ngOnInit(): void {
    this.el.nativeElement.classList.add('ripple');
  }
}
